// Imprime un elemento en un iframe aislado en vez de con window.print() sobre
// la SPA: dentro de un modal el contenido queda recortado por los contenedores
// con overflow/scroll y hereda el espacio del layout. Se copian los estilos del
// documento (<style> inyectados por vue-style-loader y <link> extraídos en
// build) y el clon conserva los atributos data-v, así que los estilos scoped
// siguen aplicando.

const BASE_PRINT_CSS = `
  @page { margin: 12mm; }
  html, body { margin: 0; padding: 0; background: #fff; }
  * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  /* Otros componentes (AlertModal) dejan en el <head> un global
     "body * { visibility: hidden }" para su propia impresión. */
  @media print {
    body, body * { visibility: visible !important; }
    .no-print { display: none !important; }
  }
`;

export default function printElement(element, { title = document.title } = {}) {
  if (!element) return;

  const iframe = document.createElement("iframe");
  iframe.setAttribute("aria-hidden", "true");
  Object.assign(iframe.style, {
    position: "fixed",
    right: "0",
    bottom: "0",
    width: "0",
    height: "0",
    border: "0"
  });
  document.body.appendChild(iframe);

  const styles = Array.from(
    document.querySelectorAll('style, link[rel="stylesheet"]')
  )
    .map(node => node.outerHTML)
    .join("\n");

  const win = iframe.contentWindow;
  const doc = win.document;
  doc.open();
  doc.write(
    `<!DOCTYPE html><html><head><meta charset="utf-8"><base href="${document.baseURI}">` +
      `${styles}<style>${BASE_PRINT_CSS}</style></head>` +
      `<body>${element.outerHTML}</body></html>`
  );
  doc.close();
  doc.title = title;

  const cleanup = () => setTimeout(() => iframe.remove(), 0);
  const run = async () => {
    // Esperar fuentes para no imprimir con la tipografía de reemplazo
    if (doc.fonts && doc.fonts.ready) await doc.fonts.ready;
    win.addEventListener("afterprint", cleanup);
    win.focus();
    win.print();
  };

  // Los <link> copiados cargan de forma asíncrona; imprimir antes deja la
  // hoja sin estilos.
  if (doc.readyState === "complete") run();
  else win.addEventListener("load", run, { once: true });
}
